exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".endorsed-logo[data-v-83692c14]{height:200px;display:inline;position:absolute;right:0;bottom:-15px;overflow:hidden}.endorsed-logo img[data-v-83692c14]{height:75px;vertical-align:middle}", ""]);

// exports
